// English, en-US

export default {
	TOGGLE_DRAWER: `Toggle menu`,
	UNFAVORITE: `Unfavorite`,
	__ASK_FOR_HELP: `* Ask for help`,
	__TIME_IS_UP: `* Time is up`,
	A_NEW_SUBSCRIPTION_WILL_BE_CREATED: `A new subscription will be created`,
	ACCOUNT_CREATED_WELCOME: `Welcome! We created a new account for you.`,
	ACCOUNT_LOGIN: `Account Login`,
	ACCOUNT_REGISTRATION: `Account Registration`,
	ACTION_FAILED: `Action failed`,
	ACTION_MENU: `Action menu`,
	ACTION_WAS_SUCCESSFUL: `Action was successful`,
	ACTIVE: `Active`,
	ACTIVE_SUBSCRIPTIONS: `Active Subscriptions`,
	ADD: `Add`,
	ADD_NEW: `Add new`,
	ADD_NEW_ASSIGNMENT: `Add new assignment`,
	ADD_TO_FAVORITES: `Add to favorites`,
	ADD_USER: `Add user`,
	ADDRESS: `Address`,
	ADVANCED_SEARCH: `Advanced search`,
	AFTER_A_MISTAKE: `After a mistake`,
	ANDROID_INSTALL_UNAVAILABLE_CAPTION: `Open the browser menu (⋮) and choose "Install app" or "Add to Home screen".`,
	ANDROID_INSTALL_UNAVAILABLE_MESSAGE: `The install prompt isn't available right now`,
	AN_ERROR_MESSAGE_WILL_BE_SHOWN: `An error message will be shown`,
	ANSWER: `Answer`,
	APPEARANCE: `Appearance`,
	APPLY: `Apply`,
	APP_INSTALLED_SUCCESSFULLY: `App installed successfully!`,
	APPROVE: `Approve`,
	APPROVE_NOTIFICATIONS_REQUEST: `In order to recieve Notifications on updates and requests, you need approve the app notifications. Do you want to see notifications? (Approve the request)`,
	APPROVED: `APPROVED`,
	ARE_YOU_SURE_REMOVE_USER_COURSE: `Are you sure you want to remove this course from your courses? All your progress will be lost.`,
	ARE_YOU_SURE_YOU_WANT_TO_DELETE: `Are you sure you want to delete`,
	ARE_YOU_SURE_YOU_WANT_TO_TOGGLE_ACTIVE: `Are you sure you want to toggle active`,
	ARE_YOU_SURE_YOU_WANT_TO_TOGGLE_PERIOD: `Are you sure you want to change the period, the next payment will be according to the period you change to.`,
	ARE_YOU_SURE_YOU_WANT_TO_UNSUBSCRIBE: `Are you sure you want to unsubscribe? No more payments will be processed. The license is availiable to the end of the period.`,
	ASSIGN: `Assign`,
	ASSIGN_LICENSE_TO_CHILD: `Assign license to child`,
	ASSIGNMENTS: `Assignments`,
	ASSIGNED_COURSES: `Assigned courses`,
	ASSIGNED_SECTIONS: `Assigned sections`,
	AT: `at`,
	AUDIO_SETTINGS: `Audio settings`,
	AUTHENTICATION_FAIL: `Authentication Failed`,
	AVAILABLE_ANSWERS: `Available answers`,
	AVERAGE_SCORE: `Average score`,
	AVATAR: `Avatar`,
	AVATAR_MANAGEMENT: `Avatar Management`,
	AVATAR_SAVED_SUCCESS: `Avatar saved successfully!`,
	AVATAR_SAVED_ERROR: `Failed to save avatar`,
	AVATAR_DELETED_SUCCESS: `Avatar deleted successfully!`,
	AVATAR_DELETED_ERROR: `Failed to delete avatar`,
	AVATAR_DOWNLOAD_PNG: `Download PNG`,
	AVATAR_DOWNLOAD_SVG: `Download SVG`,
	AVATAR_RANDOMIZE: `Randomize`,
	AVATAR_RESTORE_SAVED: `Restore saved avatar`,
	AVATAR_SAVE_TO_PROFILE: `Save to profile`,
	BACK: `Back`,
	BACK_TO_LOGIN: `Back to login`,
	BACK_TO_STEP_LIST: `Back to step list`,
	BILLING: `Billing`,
	BILLING_SETTINGS: `Billing Settings`,
	BIRTH_DATE: `Birth date`,
	BLANK_NOT_FOUND: `Blank not found`,
	BLOCK_USER: `Block User`,
	BUY_LICENSE: `Buy License`,
	CANCEL: `Cancel`,
	CANCELED: `Canceled`,
	CANCLE: `Cancle`,
	CATEGORY_BREAKDOWN: `Category breakdown`,
	CHANGE_PASSWORD: `Change Password`,
	CHECKOUT: `Checkout`,
	CHILD_ACCOUNT: `Child Account`,
	CHILD_ACCOUNT_LOGIN: `Child Account Login`,
	CHILD_LOGIN_TOKEN_INSTRUCTIONS: `Copy the login token below and send it to your child. Your child will use this token to login to their account.`,
	CHILD_LOGIN_CARD_STEP_1: `Get a login code from your parent.`,
	CHILD_LOGIN_CARD_STEP_2: `Enter the login code and click login.`,
	CHILD_LOGIN_CARD_TITLE: `How to login to your account?`,
	CHILDREN_MANAGEMENT: `Children Management`,
	CHILD_LOGIN_TOKEN_NOT_FOUND: `No login code yet. Generate one for your child.`,
	CHILED_LOGIN_TOKEN: `Child Login Token`,
	CHOOSE_A_PLAN: `Choose a plan`,
	CITY: `City`,
	CLASS: `Class`,
	CLEAR_ALL: `Clear all`,
	CLEAR_NOW: `Clear Now`,
	CLEAR_STORAGE: `Clear App Memory`,
	CLEAR_STORAGE_DESCRIPTION: `If the App is not functioning properly, clearing the app memory might help.`,
	CLEAR_STORAGE_WARNING: `Your course progress and your personal information will not be affected by this.`,
	CLOSE: `Close`,
	CODE_COPIED: `Code Copied`,
	COLLAPSE: `Collapse`,
	COLLAPSE_SIDEBAR: `Collapse Sidebar`,
	COMMENT: `Comment`,
	COMPLETED: `Completed`,
	COMPLETED_COURSES: `Completed courses`,
	COMPLETED_SECTIONS: `Completed sections`,
	COMPLETED_STEPS: `Completed steps`,
	COMPLETED_STEP_BANNER_MESSAGE: `Would you like to continue to the next step?`,
	COMPLETED_STEP_BANNER_TEXT: `You have successfully completed this step`,
	COMPLETE_STEP: `Complete step`,
	COMPLETION_FEEDBACK: `Completion Feedback`,
	CONFIRM: `Confirm`,
	CONFIRM_NEW_PASSWORD: `Confirm New Password`,
	CONFIRM_UNSUBSCRIBE: `Confirm Unsubscribe`,
	CONTENT_EMPTY_COURSE_CHILD: `You don't have any courses yet. Visit the course store and choose a course to get started.`,
	CONTENT_EMPTY_COURSE_STUDENT: `You don't have any courses yet. Your teacher assigns courses to your class — ask your teacher to assign you a course.`,
	CONTENT_EMPTY_COURSE_TITLE: `No courses yet`,
	CONTENT_EMPTY_GENERIC: `There is nothing to show here yet.`,
	CONTENT_EMPTY_SECTION_CHILD: `You don't have any sections yet. Visit the store and choose a section to get started.`,
	CONTENT_EMPTY_SECTION_STUDENT: `You don't have any sections yet. Your teacher assigns sections to your class — ask your teacher to assign you a section.`,
	CONTENT_EMPTY_SECTION_TITLE: `No sections yet`,
	CONTENT_EMPTY_TEACHER_PREVIEW: `Nothing previewed yet. Open one of your classes and press Preview on an assigned course or section.`,
	COPIED_TO_CLIPBOARD: `Copied to Clipboard`,
	COPY_CODE: `Copy Code`,
	COPY_TO_CLIPBOARD: `Copy to Clipboard`,
	CORRECT: `Correct`,
	CORRECT_ANSWER: `Correct Answer`,
	COUNTRY: `Country`,
	COURSE: `Course`,
	COURSE_ASSIGNED_SUCCESSFULLY: `Course assigned successfully`,
	COURSE_COMPLETED: `Course Completed`,
	COURSE_NAME: `Course Name`,
	COURSE_TYPE_FREE: `Free`,
	COURSE_TYPE_PREMIUM: `Premium`,
	COURSE_PREVIEW: `Course preview`,
	COURSE_REMOVED_SUCCESSFULLY: `Course removed successfully`,
	COURSE_SECTION: `Course Section`,
	COURSE_SECTIONS: `Course Sections`,
	COURSE_STORE: `Course Store`,
	COURSES: `Courses`,
	CROSSMATCH: `CrossMatch`,
	CURRENT_STREAK: `Current streak`,
	CURRENT_PASSWORD: `Current Password`,
	DAILY: `Daily`,
	DASHBOARD: `Dashboard`,
	DATE: `Date`,
	DAY: `Day`,
	DAYS_AGO: `{count} days ago`,
	DELETE: `Delete`,
	DELETE_USER: `Delete User`,
	DETAILS: `Details`,
	DIGITS_ONLY: `Digits only`,
	DISMISS: `Dismiss`,
	DONT_HAVE_AN_ACCOUNT: `Don't have an account`,
	DRILL: `Drill`,
	DRILL_DESCRIPTION: `Drill Description`,
	DRILL_TYPE: `Drill Type`,
	EDIT: `Edit`,
	EDIT_DETAILS: `Edit details`,
	EDIT_USER: `Edit user`,
	EDIT_USER_DETAILS: `Edit user details`,
	EMAIL: `Email`,
	ENABLE_EDITING: `Enable editing`,
	END_ALL: `Finish section`,
	ENROLLMENT_STATUS_ACTIVE_ACTION: `Nothing to do — pick this class in the filter to see only its courses and sections.`,
	ENROLLMENT_STATUS_ACTIVE_MESSAGE: `You are enrolled in this class. Its courses and sections are available to you now.`,
	ENROLLMENT_STATUS_COMPLETED_ACTION: `Nothing to do — well done. To join a new class, ask your teacher for an invitation.`,
	ENROLLMENT_STATUS_COMPLETED_MESSAGE: `You finished this class. Its courses and sections are no longer part of your active work.`,
	ENROLLMENT_STATUS_DECLINED_ACTION: `Check with your teacher that you picked the right class, and ask for a new invitation.`,
	ENROLLMENT_STATUS_DECLINED_MESSAGE: `Your request to join this class was declined, so you do not have access to its material.`,
	ENROLLMENT_STATUS_DROPPED_ACTION: `Contact your teacher if you think this is a mistake — they can enroll you again.`,
	ENROLLMENT_STATUS_DROPPED_MESSAGE: `You were removed from this class, so its courses and sections are no longer assigned to you.`,
	ENROLLMENT_STATUS_PENDING_ACTION: `Ask your teacher to approve your request. No further action is needed from you.`,
	ENROLLMENT_STATUS_PENDING_MESSAGE: `Your request to join this class is waiting for the teacher to approve it. Until then its courses and sections stay hidden.`,
	ENROLLMENT_STATUS_UNKNOWN_ACTION: `Try reloading the page. If it keeps showing, ask your teacher to check your enrollment.`,
	ENROLLMENT_STATUS_UNKNOWN_MESSAGE: `We could not read the status of this enrollment.`,
	ENROLLMENT_STATUS_WHAT_TO_DO: `What you can do`,
	ENTER: `Enter`,
	ENTER_YOUR_EMAIL_ADDRESS: `Enter your e-mail address`,
	ERROR: `Error`,
	ERROR_ASSIGNING_COURSE: `Error assigning course`,
	ERROR_FETCHING_DATA: `Error on fetching data`,
	ERROR_NO_ACCOUNT_FOR_EMAIL: `No account exists for this email. Ask your school to create one, then sign in.`,
	ERROR_NO_ACTIVE_ENROLLMENT: `You have no active enrollment for the current term`,
	ERROR_REMOVING_COURSE: `Error removing course`,
	EXIT: `Exit`,
	EXP: `Exp.`,
	FAILED: `Failed`,
	FAILED_TO_COPY: `Failed to copy`,
	FAILED_TO_RESET_PASSWORD: `Failed to reset password`,
	FAILED_TO_SEND_RESET_EMAIL: `Failed to send reset email`,
	FALSE: `False`,
	FAMILY: `Family`,
	FATHER: `Father`,
	FAVORITE: `Favorite`,
	FAVORITE_COURSE: `Favorite Course`,
	FEMALE: `Female`,
	FILL_IN_THE_BLANK: `Fill in the blank`,
	FILTERS: `Filters`,
	FILTER_STEP: `Filter Step`,
	FILTER_STEPS: `Filter Steps`,
	FINAL_SCORE: `Final score`,
	FIRST_ATTEMPT_SCORE: `First-attempt score`,
	FIRST_NAME: `First Name`,
	FLASH_SCHOOL_OF_ENGLISH: `flash school of english`,
	FLASH_STUDIES: `Flash Studies`,
	FOR: `for`,
	FOR_A_WEEK_PLEASE_FILL_IN_THE_PAYMENT_INFORMATION: `for a week, please fill in the payment information`,
	FOR_CHILD: `For Child`,
	FORGOT_PASSWORD: `Forgot Password`,
	FORGOT_PASSWORD_ERROR: `Forgot Password Error`,
	FREE_TRIAL: `free trial`,
	FROM: `from`,
	FULL_NAME: `Full Name`,
	GENERATE_ONE_TIME_TOKEN_FOR_CHILD: `Generate One-Time Token for Child`,
	GET_HELP: `Get help`,
	GET_PLAN: `Get Plan`,
	GO_BACK: `Go Back`,
	GO_TO_CLASSES: `Go to classes`,
	GO_TO_CHILDREN: `Go to children`,
	GO_TO_COURSE_STORE: `Go to course store`,
	GO_TO_MY_CLASSES: `Go to my classes`,
	GO_TO_MY_COURSE: `Go to my course`,
	GO_TO_MY_COURSES: `Go to my courses`,
	GO_TO_STORE: `Go to store`,
	GO_TO_NEXT: `Go to next`,
	GO_TO_PREVIOUS: `Go to previous`,
	GOOD_AFTERNOON: `Good Afternoon`,
	GOOD_EVENING: `Good Evening`,
	GOOD_MORNING: `Good Morning`,
	GOOD_NIGHT: `Good Night`,
	HAVE_AN_ACCOUNT: `Have an account?`,
	HELP: `Help`,
	HELP_USAGE: `Help usage`,
	HIDDEN_QUESTION: `Hidden Question`,
	HIDDEN_SENTENCE: `Hidden Sentence`,
	HIDE: `Hide`,
	HIDE_ADVANCED_SEARCH: `Hide advanced search`,
	HIDE_COMMENTS: `Hide Comments`,
	HIDE_COMPLETED: `Hide completed`,
	HOUR: `Hour`,
	IDENTIFICATION_NUMBER: `Identification Number`,
	IF_EMAIL_EXISTS_RESET_LINK_SENT: `If this email exists, a reset link was sent.`,
	IN_PROGRESS: `in progress`,
	INACTIVE: `Inactive`,
	INCOMPLETE: `Incomplete`,
	INFORMATION: `Information`,
	INSTALL: `Install`,
	INSTALL_APP: `Install App`,
	INSTALL_APP_PROMPT_CAPTION: `Get faster access and offline features`,
	INSTALL_APP_PROMPT_MESSAGE: `Install SET App`,
	IOS_INSTALL_TITLE: `Install on iPhone / iPad`,
	IOS_INSTALL_STEP0: `Installing the App can only be done through Safari`,
	IOS_INSTALL_STEP1: `Open Safari and go to this website`,
	IOS_INSTALL_STEP2: `Tap the Share button (square with an arrow)`,
	IOS_INSTALL_STEP3: `Select [Add to Home Screen], then tap [Add]`,
	IOS_INSTALL_NOTE: `After adding, open the app from the Home Screen`,
	INSTRUCTIONS: `Instructions`,
	INTERIM_RESULTS: `Interim Results`,
	INVALID_NAME_FORMAT: `Name can only contain letters, spaces, hyphens and apostrophes`,
	INVALID_VALUE: `Invalid value`,
	IT_WAS_WRITTEN_AS_AN_ERROR_AND_IMPACT_YOUR_SCORE: `It was written as an error and will impact your score`,
	IT_WILL_COUNT_AS_AN_ERROR: `It will count as an error`,
	IT_WILL_NOT_COUNT_AS_AN_ERROR: `It will not count as an error`,
	LANGUAGE_SELECT: `Language`,
	LAST_NAME: `Last Name`,
	LAST_PRACTICE: `Last practice`,
	LATER: `Later`,
	LICENSE: `License`,
	LICENSE_ASSIGNED_SUCCESSFULLY_TO_CHILD: `License assigned successfully to child`,
	LICENSE_EXPIRED: `License Expired`,
	LICENSE_REQUIRED_FOR_PREMIUM: `This premium course requires an active license.`,
	LICENSE_REQUIRED_REDIRECT_COURSES: `Your license is invalid for premium content. Redirecting to the course store.`,
	LICENSE_VALID_UNTIL: `License valid until`,
	LICENSES: `Licenses`,
	LOCKED_FOR_STUDENTS: `Locked for students`,
	LOCKED_PREMIUM_COURSE: `Premium locked`,
	LOCATION: `Location`,
	LOGIN: `Login`,
	LOGIN_TOKEN: `Login Token`,
	LOGOUT: `Logout`,
	LONGEST_STREAK: `Longest streak`,
	MAIN_ACCOUNT: `Main Account`,
	MALE: `Male`,
	MANUAL_COPY_INSTRUCTION: `Please select all text below and copy it manually:`,
	MAXIMUM_50_CHARACTERS: `Maximum 50 characters`,
	MAX_AGE: `Max Age`,
	MAX_CHARACTERS: `Max Characters`,
	MEMORY_FLIP: `Memory Flip`,
	MESSAGES: `Messages`,
	MIC_NOT_SUPPORTED: `Speaking is not supported in this browser — type your answer`,
	MIN_AGE: `Min Age`,
	MIN_CHARACTERS: `Min Characters`,
	MOBILE_NOT_FOUND: `Mobile not found`,
	MOBILE_NUMBER: `Mobile Number`,
	MOBILE_NUMBER_10_DIGITS: `Mobile number, 10 digits`,
	MOBILE_PHONE: `Mobile`,
	MONTH: `Month`,
	MONTHLY: `Monthly`,
	MOTHER: `Mother`,
	MY_CLASSES: `My classes`,
	MY_COURSES: `My Courses`,
	MY_FAVORITES: `My Favorites`,
	MY_PROFILE: `My profile`,
	MY_PROFILE_DETAILS: `My profile details`,
	MY_SECTIONS: `My Sections`,
	MY_STEPS: `My Steps`,
	NAME: `Name`,
	NAME_2_TO_64: `2 to 64 characters`,
	NAVIGATION_MENU: `Navigation Menu`,
	NEW_MESSAGE: `New Message`,
	NEW_PASSWORD: `New Password`,
	NEW_TO_OUR_SYSTEM: `New to our system?`,
	NEW_USER: `New user`,
	NEXT: `Next`,
	NEXT_STEP: `Next step`,
	NO: `No`,
	NO_CHILDREN_AVAILABLE: `No children available`,
	NO_COURSES_AVAILIABLE_IN_STORE: `No courses availiable in store`,
	NO_DATA_AVAILIABLE: `No data availiable`,
	NO_ERROR_MESSAGE_WILL_BE_SHOWN: `No error message will be shown`,
	NO_FEEDBACK_AVAILABLE: `No feedback available`,
	NO_LICENSE: `No license`,
	NO_TASKS_MATCH_FILTERS: `No tasks match the current filters`,
	NO_VALID_PAYMENT_DATA_FOUND_CHECKOUT_TO_PAY: `No valid payment data found, checkout to pay`,
	NOT_SET: `Not Set`,
	NOT_STARTED: `Not Started`,
	NOTIFICATIONS_APPROVED: `Notifications approved!`,
	NOTIFICATIONS_WERE_NOT_APPROVED: `Notifications are not approved, you can change that by clicking the icon on the adress bar (before the url) and selecting, 'site settings', then find the 'Notifications' permissions and set it.`,
	NO_FAVORITES_AVAILABLE: `No favorites yet`,
	OF: `of`,
	OKAY: `Okay`,
	OOPS_THIS_IS_THE_WRONG_ANSWER: `Oops! this is the wrong answer`,
	ORGANIZATION: `Organization`,
	ORGANIZATION_DETAILS: `Organization Details`,
	ORGANIZATION_NAME: `Organization Name`,
	ORGANIZATION_TYPE: `Organization Type`,
	ORGANIZATIONS: `Organizations`,
	ORGANIZATIONS_LIST: `Organizations List`,
	OTHER: `Other`,
	OWNED: `Owned`,
	PAIRS: `Pairs`,
	PARENT_ACCOUNT_LOGIN: `Parent Account Login`,
	PASSWORD: `Password`,
	PASSWORD_RESET_SUCCESSFUL: `Password reset successful`,
	PASSWORD_UPDATED: `Password Updated`,
	PASSWORDS_MUST_MATCH: `Passwords Must Match`,
	PAUSE: `Pause`,
	PAYMENT: `payment`,
	PAYMENT_CONFIRMATION_TEXT: `It might take up to 10 minutes to process your payment. Nevertheless, we will activate your license, if the payment is declined the license will be deactivated.`,
	PAYMENT_CONFIRMATION_TITLE: `Order Received`,
	PERIOD: `Period`,
	PHONE: `Phone`,
	PHONE_NUMBER: `Phone Number`,
	PITCH: `Pitch`,
	PLAN: `Plan`,
	PLAN_ERROR: `Plan Error`,
	PLAN_INFORMATION: `Plan Information`,
	PLEASE_ENTER_A_VALID_EMAIL_ADDRESS: `Please enter a valid email address`,
	PLEASE_ENTER_A_VALID_PASSWORD: `Please enter a valid password`,
	PLEASE_ENTER_A_VALUE: `Please enter a value`,
	PRACTICE: `Practice`,
	PRESS_THE_PLAY_BUTTON_TO_HERE_THE_QUESTION: `Press the play button to here the question`,
	PRICE: `Price`,
	PREVIEW: `Preview`,
	PREVIEW_FAILED: `Could not open the preview`,
	PROCESSING: `Processing...`,
	PROFILE: `Profile`,
	PROFILE_SETTINGS: `Profile Settings`,
	PROGRESS_OVERVIEW: `Progress overview`,
	PROGRESS_SAVE_FAILED: `Your progress could not be saved. Check your connection.`,
	PUT_THE_WORDS_IN_ORDER: `Put the words in order`,
	QUERY: `Query`,
	RATE: `Rate`,
	RECIEVE_NOTIFICATIONS: `Recieve Notifications`,
	REDO_CURRENT: `Redo current`,
	REDO_SECTION: `Redo Section`,
	REGISTER: `Register`,
	REGISTRATION: `Registration`,
	REJECTED: `Rejected`,
	RECENT_ACTIVITY: `Recent activity`,
	REMOVE_COURSE: `Remove Course`,
	REMOVE_FROM_FAVORITES: `Remove from favorites`,
	REQUESTED: `REQUESTED`,
	REQUIRED: `This field is required`,
	RESET: `Reset`,
	RESET_CODE_MISSING: `Reset code missing`,
	RESET_PASSWORD: `Reset Password`,
	RESET_PASSWORD_ERROR: `Reset password error`,
	RESET_STEP: `Reset step`,
	RESTART_COURSE: `Restart Course`,
	RESTART_SECTION: `Restart Section`,
	RETRY: `Retry`,
	RETYPE_PASSWORD: `Retype Password`,
	ROLE: `Role`,
	SAVE: `Save`,
	SAY_YOUR_ANSWER: `Tap the microphone and say your answer`,
	SCHOOL: `School`,
	SCHOOL_ACCOUNT_LOGIN: `School account login`,
	SCHOOL_ACCOUNT_REGISTRATION: `School account registration`,
	SCHOOL_ADMIN_ACCOUNT: `School admin account`,
	SCHOOL_ALL_CLASSES: `All classes`,
	SCHOOL_ALL_SCHOOLS: `All schools`,
	SCHOOL_ALLOW_FUTURE_ASSIGNMENTS: `Allow assigning ahead`,
	SCHOOL_ALL_SEMESTERS: `All semesters`,
	SCHOOL_APPLICATION_CANCELLED: `Application cancelled`,
	SCHOOL_APPLIED: `Applied`,
	SCHOOL_APPLY: `Apply`,
	SCHOOL_APPLY_SUCCESS: `Application submitted. Waiting for teacher approval.`,
	SCHOOL_ASSIGNED_COUNT: `Assigned`,
	SCHOOL_ASSIGNED_COURSES: `Assigned courses`,
	SCHOOL_ASSIGNED_LABEL: `Assigned`,
	SCHOOL_ASSIGNED_STUDENTS_COUNTER: `{assignedCount} of {totalCount} students assigned`,
	SCHOOL_ASSIGN_COURSE: `Assign course`,
	SCHOOL_ASSIGN_INACTIVE_STUDENT: `Only active students can be given new work.`,
	SCHOOL_ASSIGN_LOCKED_FUTURE: `This semester has not started. Turn on \"Allow assigning ahead\" to assign courses and sections.`,
	SCHOOL_ASSIGN_LOCKED_PAST: `This semester has ended. You can remove assignments, but not add new ones.`,
	SCHOOL_ASSIGN_LOCKED_SEMESTER: `Assigning is locked for this semester.`,
	SCHOOL_ASSIGN_COURSE_FAILED: `Failed to assign course to class`,
	SCHOOL_ASSIGN_COURSE_SUMMARY: `Assigned to {createdCount} students ({existingCount} already assigned)`,
	SCHOOL_ASSIGN_COURSE_TO_STUDENTS: `Assign to students`,
	SCHOOL_BULK_ASSIGNMENT_SUMMARY: `Assigned {courseCount} courses and {sectionCount} sections to {studentCount} students ({changedCount} changes, {unchangedCount} unchanged)`,
	SCHOOL_CANCEL_APPLICATION: `Cancel application`,
	SCHOOL_CLASS_APPROVE: `Approve`,
	SCHOOL_CLASS_COURSE_ASSIGNMENT: `Class course assignment`,
	SCHOOL_CLASS_DECLINE: `Decline`,
	SCHOOL_CLASS_DROP: `Drop`,
	SCHOOL_CLASS_DROP_CONFIRM: `Remove {name} from this class? This ends their enrollment for the semester.`,
	SCHOOL_CLASS_REINSTATE: `Reinstate`,
	SCHOOL_CLASS_REINSTATE_CONFIRM: `Reinstate {name} in this class? They regain access to its courses and continue from where they left off.`,
	SCHOOL_COMPLETED_COUNT: `Completed`,
	SCHOOL_COPY_ENROLLMENT_LINK: `Copy enrollment link`,
	SCHOOL_COPY_REGISTRATION_LINK: `Copy registration link`,
	SCHOOL_CREATE_ENROLLMENT: `Create enrollment`,
	SCHOOL_CURRENT_SEMESTER: `Current semester: {name}`,
	SCHOOL_DECISION_SAVED: `Decision saved`,
	SCHOOL_ENROLLED: `Enrolled`,
	SCHOOL_ENROLLMENT_CREATE_SUCCESS: `Enrollment created successfully`,
	SCHOOL_ENROLLMENT_DOCUMENT_ID: `Enrollment document ID`,
	SCHOOL_ENROLLMENT_LINK_COPIED: `Enrollment link copied`,
	SCHOOL_ENROLLMENT_LINK_EXPLAIN: `For students who already have an account — one click sends a request to join this class, which you then approve.`,
	SCHOOL_ENROLLMENT_STATUS_LABEL: `Enrollment: {status}`,
	SCHOOL_FIND_CLASSES: `Find classes`,
	SCHOOL_HIDE_INACTIVE_STUDENTS: `Hide inactive`,
	SCHOOL_INVITE_CLOSED_PAST_SEMESTER: `Invite links are unavailable for a semester that has ended.`,
	SCHOOL_INVITE_FOR_SEMESTER: `For semester: {name}`,
	SCHOOL_INVITE_LINKS: `Invite links`,
	SCHOOL_INVITE_LINKS_HINT: `Share a link to bring students into this class.`,
	SCHOOL_JOIN_ERROR_CLASS_NOT_FOUND: `We couldn't find this class. The invitation link may be invalid or the class is no longer available.`,
	SCHOOL_JOIN_ERROR_CLOSED: `This invitation can no longer be used to join the class.`,
	SCHOOL_JOIN_ERROR_COMPLETED: `You've already completed this class, so there's nothing to join.`,
	SCHOOL_JOIN_ERROR_DECLINED: `Your request to join this class was declined. Ask your teacher for a new invitation.`,
	SCHOOL_JOIN_ERROR_DROPPED: `You were removed from this class. Contact your teacher if you think this is a mistake.`,
	SCHOOL_JOIN_ERROR_GENERIC: `Something went wrong while joining this class. Please try again.`,
	SCHOOL_JOIN_ERROR_INVALID_LINK: `This invitation link is invalid or has expired.`,
	SCHOOL_JOIN_ERROR_SEMESTER_ENDED: `This class's term has ended, so it's no longer open for enrollment.`,
	SCHOOL_JOIN_ERROR_TITLE: `Couldn't join this class`,
	SCHOOL_JOIN_GO_HOME: `Go to dashboard`,
	SCHOOL_JOIN_RETRY: `Try again`,
	SCHOOL_JOIN_STUDENTS_ONLY: `Only students can join a class.`,
	SCHOOL_JOIN_SUCCESS: `Request sent — your teacher needs to approve you.`,
	SCHOOL_LOGIN_ROLE_MISMATCH: `Selected role does not match your account role.`,
	SCHOOL_NO_ASSIGNED_CLASSES_FOUND: `No assigned classes found.`,
	SCHOOL_NO_CLASSES_ASSIGNED_IN_SEMESTER: `There are no classes assigned to you in this semester.`,
	SCHOOL_NO_CLASSES_AVAILABLE: `No classes available for this school.`,
	SCHOOL_NO_CLASSES_FOR_SELECTED_SEMESTER: `No classes found for the selected semester.`,
	SCHOOL_NO_CURRENT_SEMESTER: `There is no active semester right now. Enrollment is closed.`,
	SCHOOL_NO_ENROLLMENTS_FOR_THIS_SEMESTER: `No enrollments found for this semester.`,
	SCHOOL_NO_STUDENTS_FOUND_FOR_CLASS: `No students found for this class`,
	SCHOOL_NO_STUDENTS_MATCH_FILTER: `No students match the selected statuses`,
	SCHOOL_NOT_ASSIGNED_LABEL: `Not assigned`,
	SCHOOL_NOTES: `Notes`,
	SCHOOL_PROGRESS_PAUSED_SHORT: `Progress paused`,
	SCHOOL_REGISTER_SUCCESS: `School account created. Sign in with your credentials.`,
	SCHOOL_REGISTRATION_LINK_COPIED: `Registration link copied`,
	SCHOOL_REGISTRATION_LINK_EXPLAIN: `For students without an account yet — they register, and a request to join this class is sent for you to approve.`,
	SCHOOL_SCORE_LABEL: `Score: {score}`,
	SCHOOL_SEMESTER_LABEL: `Semester: {name}`,
	SCHOOL_SELECTED_COURSE: `Selected course`,
	SCHOOL_SELECT_ASSIGNED_COURSE_TO_VIEW_PROGRESS: `Select an assigned course card to view student progress.`,
	SCHOOL_SELECT_SCHOOL: `Select school`,
	SCHOOL_SELECT_SEMESTER_TO_VIEW: `Select a semester to view classes.`,
	SCHOOL_SHOW_INACTIVE_STUDENTS: `Show inactive ({count})`,
	SCHOOL_STATUS_ACTIVE: `Active`,
	SCHOOL_STATUS_COMPLETED: `Completed`,
	SCHOOL_STATUS_DECLINED: `Declined`,
	SCHOOL_STATUS_DROPPED: `Dropped`,
	SCHOOL_STATUS_PENDING: `Pending`,
	SCHOOL_STUDENT_DOCUMENT_ID: `Student document ID`,
	SCHOOL_STUDENTS_PROGRESS_FOR_COURSE: `Students progress for this course`,
	SCHOOL_STUDENTS_COUNT: `Students`,
	SCHOOL_UNASSIGNED_PROGRESS_PAUSED_MESSAGE: `Progress for unassigned content is paused.`,
	SCHOOL_UPDATE_ENROLLMENT: `Update enrollment`,
	SCHOOL_ENROLLMENT_UPDATE_SUCCESS: `Enrollment updated successfully`,
	SCHOOL_LAST_ACTIVE: `Active {when}`,
	SCHOOL_NEVER_ACTIVE: `Never signed in`,
	SCHOOL_SELECT_ALL: `Select all`,
	SCHOOL_UNASSIGN: `Unassign`,
	SCHOOL_UNASSIGN_COMPLETED_CONFIRM: `{name} already completed {entity}. Unassigning hides it from them; their progress and score are kept and come back if you assign it again. Unassign anyway?`,
	SCHOOL_UNASSIGN_STARTED_CONFIRM: `{name} has already started {entity}. Unassigning stops them from continuing; their progress is kept and comes back if you assign it again. Unassign anyway?`,
	SCHOOL_UNASSIGN_STARTED_TITLE: `Student already started`,
	SCHOOL_UNSELECT_ALL: `Clear all`,
	SCORE: `Score`,
	SEARCH: `Search`,
	SEARCH_BY_NAME: `Search by name`,
	SECTION: `Section`,
	SECTION_COMPLETED: `Section Completed`,
	SECTION_PREVIEW: `Section preview`,
	SECTION_STORE: `Section Store`,
	SECTIONS: `Sections`,
	SECURITY: `Security`,
	SECURITY_SETTINGS: `Security Settings`,
	SELECT: `Select`,
	SELECTED_PLAN: `Selected plan`,
	SELECT_ALL: `Select all`,
	SELECT_AND_ASSIGN: `Select and assign`,
	SELECT_AND_COPY_TEXT_BELOW: `Select and copy text below`,
	SELECT_APPEARANCE: `Choose your theme`,
	SELECT_CITY_FIRST: `Please select a city first`,
	SELECT_LANGUAGE: `Select Language`,
	SELECT_ONE_OPTION_TO_ANSWER: `Select one option to answer`,
	SELECT_SYSTEM_LANGUAGE: `Select System Language`,
	SEND_REQUEST: `Send Request`,
	SEND_RESET_LINK: `Send Reset Link`,
	SENTENCE_BUILDER: `Sentence Builder`,
	SETTINGS: `settings`,
	SEX: `Sex`,
	SEMESTER: `Semester`,
	SEMESTER_TAG_CURRENT: `Current`,
	SEMESTER_TAG_PAST: `Past`,
	SEMESTER_TAG_UPCOMING: `Upcoming`,
	SHARE_CODE: `Share Code`,
	SHOW_COMMENTS: `Show Comments`,
	SHOW_INFO: `Show info`,
	SIGN_IN: `Sign In`,
	SIGN_IN_SUCCESS: `Successfuly signed in`,
	SIGN_OUT: `Sign Out`,
	SIGNING_IN: `Signing In`,
	SINGLE_CHOICE: `Single Choice`,
	SKIP: `Skip`,
	SKIPPED: `Skipped`,
	SOMETHING_WENT_WRONG: `Something went wrong`,
	SORT: `Sort`,
	SORT_BY: `Sort by`,
	SORT_HIGHEST_SCORE_FIRST: `Highest score first`,
	SORT_LOWEST_SCORE_FIRST: `Lowest score first`,
	SORT_NAME_A_Z: `Name A–Z`,
	SORT_RECENTLY_WORKED_ON: `Recently worked on`,
	SPEAK_THE_TEXT: `Speak the text`,
	START: `Start`,
	START_DATE: `Start Date`,
	STATUS: `Status`,
	STEP: `Step`,
	STEP_INCOMPLETE_DATA: `Incomplete Step Data`,
	STEP_LOAD_ERROR: `Error Loading Step`,
	STEP_NOT_FOUND: `Step not found`,
	STEP_RESULTS: `Step Results`,
	STEPS: `Steps`,
	STEP_FEEDBACK_GO_BACK_MESSAGE: `Go back to the previous step, then try this one again.`,
	STEP_FEEDBACK_GO_BACK_TITLE: `Let's go back one step`,
	STEP_FEEDBACK_PASS_SCORE: `You need {score}% to move on.`,
	STEP_FEEDBACK_REDO_MESSAGE: `Let's practise this step once more.`,
	STEP_FEEDBACK_REDO_TITLE: `Let's try this step again`,
	STEP_FEEDBACK_SCORE: `You scored {score}%.`,
	STOP: `Stop`,
	STORAGE_CLEARED_ERROR: `App memory couldn't be cleared. Try again.`,
	STORAGE_CLEARED_SUCCESS: `App memory cleared successfully`,
	STORAGE_CLEARED_SUCCESS_CAPTION: `The app memory was cleared successfully. You can now continue.`,
	STREET: `Street`,
	STREET_NUMBER: `Street Number`,
	STUDENT: `Talmid`,
	STUDENT_ACCOUNT: `Student Account`,
	STUDENT_MY_CLASSES: `My classes`,
	STUDENT_NO_CLASSES: `You are not enrolled in any class yet. Ask your teacher for a join link.`,
	STUDENT_NO_CLASSES_IN_SEMESTER: `No classes in this semester.`,
	STUDENT_SEMESTER_CURRENT: `Current semester`,
	STUDENT_SEMESTER_UPCOMING: `Upcoming semester`,
	STUDENT_STATISTICS: `Student statistics`,
	STUDENTS: `Students`,
	SUBMIT: `Submit`,
	SUBSCRIPTION_CREATED_SUCCESSFULLY: `Subscription created successfully`,
	SUBSCRIPTION_UPDATED_SUCCESSFULLY: `Subscription updated successfully`,
	SUPER_ADMIN: `Super Admin`,
	SYSTEM_LANGUAGE: `System Language`,
	TAKE_COURSE: `Take Course`,
	TEACHER_PREVIEW_BANNER: `Preview mode — you are viewing this content as your students will. Your progress here is not student progress.`,
	TEACHER_ACCOUNT: `Teacher Account`,
	TEACHERS: `Teachers`,
	TERMS_OF_TRANSITION: `Terms of transition`,
	THEME_DARK: `Dark`,
	THEME_LIGHT: `Light`,
	THEME_SYSTEM: `System`,
	THE_QUESTION_IS_HEARD: `The question is heard`,
	THE_QUESTION_IS_NOT_HEARD: `The question is not heard`,
	THE_QUESTION_TEXT_IS_NOT_SHOWN: `The question text is not shown`,
	THE_QUESTION_TEXT_IS_SHOWN: `The question text is shown`,
	THE_SUBSCRIPTION_PERIOD_WILL_BE_CHANGED_TO: `The subscription period will be changed to {period}`,
	THEORY_STEP: `Theory Step`,
	THEORY_STEP_INFORMATION_TEXT: `Theory step information text`,
	TIME: `Time`,
	TITLE: `Title`,
	TO: `to`,
	TO_GET_A: `To get a`,
	TODAY: `Today`,
	TOGGLE: `Toggle`,
	TOTAL: `Total`,
	TOTAL_USAGE_TIME: `Total usage time`,
	TRUE: `True`,
	TRUE_FALSE: `True / False`,
	TRY_AGAIN: `Try Again`,
	TYPE: `Type`,
	TYPE_INSTEAD: `Type instead`,
	TYPE_OR_SAY_YOUR_ANSWER_HERE: `Type or say your answer here`,
	TYPE_YOUR_ANSWER_HERE: `Type your answer here`,
	UNASSIGNED_LICENSE: `Unassigned License`,
	UNFAVORITE_COURSE: `Unfavorite Course`,
	UNFORTUNATLY_WE_COULD_NOT_LOAD_THE_USER_DATA: `Unfortunatly we could not load the user data`,
	UNKNOWN: `Unknown`,
	UNSUBSCRIBE: `Unsubscribe`,
	UNSUBSCRIBE_FAILED: `Unsubscribe failed`,
	UNSUBSCRIBED_SUCCESSFULLY: `Unsubscribed Successfully`,
	UPDATE: `Update`,
	UPDATE_SUBSCRIPTION_PERIOD_FAILED: `Failed to update subscription period`,
	UPDATE_SUBSCRIPTION_PERIOD_SUCCESS: `Subscription period updated successfully`,
	USER_DETAILS: `User details`,
	USER_MANAGEMENT: `User Management`,
	USER_MANAGMENT: `User Managment(staff)`,
	USER_NOT_FOUND: `User Not Found`,
	USERNAME: `Username`,
	USERNAME_OR_EMAIL: `Username/Email`,
	USERS: `Users`,
	USERS_LIST: `Users List`,
	USER_NOT_LOGGED_IN: `You are not signed in`,
	VALID_EMAIL_ADDRESS: `Valid email address`,
	VALID_UNTIL: `Valid until`,
	VALIDATE_INVALID_PHONE: `Valid Mobile Phone Required`,
	VALIDATE_MIN_2_CHARS: `At least 2 characters`,
	VALIDATE_MIN_2_MAX_20: `The value should be 2 to 20 characters`,
	VERIFY: `Verify`,
	VIDEO_LOADING: `Loading video…`,
	VIDEO_LOAD_ERROR: `The video couldn't be loaded`,
	VIEW_RESULTS: `View results`,
	VIEW_STATISTICS: `View statistics`,
	WEELKLY: `Weekly`,
	WELCOME_BACK_MESSAGE: `Ready to continue your learning journey?`,
	WELCOME_BACK_MESSAGE_PARENT: `Welcome back! Choose a child to continue their learning journey.`,
	WELCOME_BACK_MESSAGE_STUDENT: `Welcome back! Ready to continue learning?`,
	WELCOME_BACK_MESSAGE_TEACHER: `Welcome back! Here's an overview of your classes.`,
	WELCOME_TO: `Welcome to`,
	WHEN_YOU_HAVE_A_MISTAKE: `When you have a mistake`,
	WORD_BUILDER: `Word Builder`,
	WRONG_ANSWER: `Wrong Answer`,
	YEAR: `Year`,
	YEARLY: `Yearly`,
	YES: `Yes`,
	YOU_CAN_CORRECT_YOUR_ANSWER_THE_QUESTION_WILL_REPEATE: `You can correct your answer, the question will repeate`,
	YOU_CAN_NOT_CORRECT_YOUR_ANSWER_THE_NEXT_QUESTION_WILL_BE_SHOWN: `You can not correct your answer, the next question will be shown`,
	YOU_DID_GOOD_ON_PREVIOUS_STEPPS_THIS_FILTER_STEP_IS_NOT_NEEDED: `You did good on previous steps, this filter step is not needed`,
	YOU_DID_GOOD_ON_PREVIOUS_STEPS: `You did good on previous steps`,
	YOU_DID_NOT_MEET_THE_TERMS_OF_TRANSITION_FOR_THE_SECTION_REDO: `You did not meet the terms of transition for the section, redo?`,
	YOU_HAVE_COMPLETED_THIS_COURSE_BACK_TO_COURSES: `You have completed this course! Back to courses`,
	YOU_HAVE_COMPLETED_THIS_SECTION_WOULD_YOU_LIKE_TO_PROCEED: `You have completed this section. Would you like to proceed?`,
	YOU_HAVE_COMPLETED_THIS_STEP: `You have completed this step`,
	YOU_WILL_BE_SHOWN_THE_ANSWER_COMPARISON: `You will be shown the answer comparison`,
	YOUR_ANSWER: `Your Answer`,
	YOUR_SECTIONS: `Your Sections`,
	YOUR_SUBSCRIPTION_WILL_ONLY_UPDATE_THE_PRICE: `Your subscription will only update the price`,
	ZIPCODE: `Zipcode`,
}